import { useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import NavBar from "./components/NavBar";
import MainMint from "./components/MainMint";

function App() {
  const [accounts, setAccounts] = useState([]);
  const contractAddress = "0x0dfE95776a2189A3DD7534498c79244Cb6B97baD";
  return (
    <div className="overlay">
      <div className="App">
        <NavBar
          accounts={accounts}
          setAccounts={setAccounts}
          contractAddress={contractAddress}
        />
        <MainMint
          accounts={accounts}
          setAccounts={setAccounts}
          contractAddress={contractAddress}
        />
      </div>
      <div className="wallpaper"></div>
    </div>
  );
}

export default App;
